/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseThumbsDownListData } from './genericApiResponseThumbsDownListData';
import type { GenericApiResponseThumbsDownListMessage } from './genericApiResponseThumbsDownListMessage';
import type { GenericApiResponseThumbsDownListPagination } from './genericApiResponseThumbsDownListPagination';
import type { GenericApiResponseThumbsDownListError } from './genericApiResponseThumbsDownListError';

export interface GenericApiResponseThumbsDownList {
  data?: GenericApiResponseThumbsDownListData;
  message?: GenericApiResponseThumbsDownListMessage;
  pagination?: GenericApiResponseThumbsDownListPagination;
  error?: GenericApiResponseThumbsDownListError;
  statusCode?: number;
}
